import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const housingSelectionAssistantPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.housingSelectionAssistant(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<void>>("/page-data/housingselectionassistant"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
